import { meshModules } from 'Deer/constants/modules';
import { L3_PATHS } from 'Deer/constants/routes';
import { getUserAccess, getUserL2Access } from 'Deer/helpers/getUserAccess';
import { checkVisierAnalyticsEnabled } from 'utils/helpers/featureFlags';

export const L2_MODULES_MY_DATA = {
  overview: {
    label: meshModules.overview.label,
    value: L3_PATHS['my-data'].overview.myDataOverview,
    key: meshModules.overview.value,
    checkModuleIsEnabled: () => checkVisierAnalyticsEnabled(),
    order: 1,
  },
  checkIns: {
    label: meshModules.checkIns.label,
    value: L3_PATHS['my-data'].checkIns.nextCheckIns,
    key: meshModules.checkIns.value,
    checkModuleIsEnabled: () => getUserL2Access().hasCheckInsAccess,
    order: 2,
  },
  goals: {
    label: meshModules.goals.label,
    value: L3_PATHS['my-data'].goal.myGoals,
    key: meshModules.goals.value,
    checkModuleIsEnabled: () => getUserL2Access().hasGoalAccess,
    order: 3,
  },
  develop: {
    label: meshModules.develop.label,
    value: L3_PATHS['my-data'].develop.competencies,
    key: meshModules.develop.value,
    checkModuleIsEnabled: () => getUserL2Access().hasFeedbackAccess,
    order: 4,
  },
  oneOnOne: {
    label: meshModules.oneOnOne.label,
    value: L3_PATHS['my-data'].oneOnOne.myOneOnOne,
    key: meshModules.oneOnOne.value,
    checkModuleIsEnabled: () => getUserL2Access().hasOneOnOneAccess,
    order: 5,
  },
  review: {
    label: meshModules.review.label,
    value: L3_PATHS['my-data'].review.myReviews,
    key: meshModules.review.value,
    checkModuleIsEnabled: () => getUserL2Access().hasReviewAccess,
    order: 6,
  },
  engagement: {
    label: meshModules.engagement.label,
    value: L3_PATHS['my-data'].engagement.mySurveys,
    key: meshModules.engagement.value,
    checkModuleIsEnabled: () => getUserL2Access().hasEngagementAccess,
    order: 7,
  },
  initiatives: {
    label: meshModules.initiatives.label,
    value: L3_PATHS['my-data'].initiative.myInitiatives,
    key: meshModules.initiatives.value,
    checkModuleIsEnabled: () => getUserL2Access().hasInitiativeAccess,
    order: 8,
  },
  disciplinaryActions: {
    label: meshModules.disciplinaryActions.label,
    value: L3_PATHS['my-data'].disciplinaryActions.pendingDisciplinaryActions,
    key: meshModules.disciplinaryActions.value,
    checkModuleIsEnabled: () => getUserL2Access().hasDisciplinaryActionsAccess,
    order: 6,
  },
};

const L2_MODULES_TEAM_DIRECT_REPORTS = {
  overview: {
    label: meshModules.overview.label,
    value: L3_PATHS.team.directReports.overview.myTeamOverview,
    key: meshModules.overview.value,
    checkModuleIsEnabled: () => checkVisierAnalyticsEnabled(),
    order: 1,
  },
  goals: {
    label: meshModules.goals.label,
    value: L3_PATHS.team.directReports.goal.manage,
    key: meshModules.goals.value,
    checkModuleIsEnabled: () => getUserL2Access().hasGoalAccess,
    order: 2,
  },
  develop: {
    label: meshModules.develop.label,
    value: L3_PATHS.team.directReports.develop.manage,
    key: meshModules.develop.value,
    checkModuleIsEnabled: () => getUserL2Access().hasFeedbackAccess,
    order: 3,
  },
  oneOnOne: {
    label: meshModules.oneOnOne.label,
    value: L3_PATHS.team.directReports.oneOnOne.manage,
    key: meshModules.oneOnOne.value,
    checkModuleIsEnabled: () => getUserL2Access().hasOneOnOneAccess,
    order: 4,
  },
  review: {
    label: meshModules.review.label,
    value: L3_PATHS.team.directReports.review.manage,
    key: meshModules.review.value,
    checkModuleIsEnabled: () => getUserL2Access().hasReviewAccess,
    order: 5,
  },
  engagement: {
    label: meshModules.engagement.label,
    value: L3_PATHS.team.directReports.engagement.insights,
    key: meshModules.engagement.value,
    checkModuleIsEnabled: () => getUserL2Access().hasEngagementAccess,
    order: 6,
  },
  disciplinaryActions: {
    label: meshModules.disciplinaryActions.label,
    value: L3_PATHS.team.directReports.disciplinaryActions.pendingDisciplinaryActions,
    key: meshModules.disciplinaryActions.value,
    checkModuleIsEnabled: () => getUserL2Access().hasDisciplinaryActionsAccess,
    order: 7,
  },
};

const L2_MODULES_TEAM_ALL_REPORTS = {
  overview: {
    label: meshModules.overview.label,
    value: L3_PATHS.team.allReports.overview.mySkipTeamOverview,
    key: meshModules.overview.value,
    checkModuleIsEnabled: () => checkVisierAnalyticsEnabled(),
    order: 1,
  },
  goals: {
    label: meshModules.goals.label,
    value: L3_PATHS.team.allReports.goal.manage,
    key: meshModules.goals.value,
    checkModuleIsEnabled: () => getUserL2Access().hasGoalAccess,
    order: 2,
  },
  develop: {
    label: meshModules.develop.label,
    value: L3_PATHS.team.allReports.develop.insights,
    key: meshModules.develop.value,
    checkModuleIsEnabled: () => getUserL2Access().hasFeedbackAccess,
    order: 3,
  },
  oneOnOne: {
    label: meshModules.oneOnOne.label,
    value: L3_PATHS.team.allReports.oneOnOne.manage,
    key: meshModules.oneOnOne.value,
    checkModuleIsEnabled: () => getUserL2Access().hasOneOnOneAccess,
    order: 4,
  },
  review: {
    label: meshModules.review.label,
    value: L3_PATHS.team.allReports.review.manage,
    key: meshModules.review.value,
    checkModuleIsEnabled: () => getUserL2Access().hasReviewAccess,
    order: 5,
  },
  engagement: {
    label: meshModules.engagement.label,
    value: L3_PATHS.team.allReports.engagement.insights,
    key: meshModules.engagement.value,
    checkModuleIsEnabled: () => getUserL2Access().hasEngagementAccess,
    order: 6,
  },
  disciplinaryActions: {
    label: meshModules.disciplinaryActions.label,
    value: L3_PATHS.team.allReports.disciplinaryActions.pendingDisciplinaryActions,
    key: meshModules.disciplinaryActions.value,
    checkModuleIsEnabled: () => getUserL2Access().hasDisciplinaryActionsAccess,
    order: 7,
  },
};

const L2_MODULES_TEAM_VIEW = {
  goals: {
    label: meshModules.goals.label,
    value: L3_PATHS.team.view.goal.manage,
    key: meshModules.goals.value,
    checkModuleIsEnabled: () => getUserL2Access().hasGoalAccess,
    order: 1,
    featureKey: 'GOAL',
  },
  review: {
    label: meshModules.review.label,
    value: L3_PATHS.team.view.review.manage,
    key: meshModules.review.value,
    checkModuleIsEnabled: () => getUserL2Access().hasReviewAccess,
    order: 4,
    featureKey: 'REVIEW',
  },
};

export const L2_MODULES_TEAM = {
  directReports: L2_MODULES_TEAM_DIRECT_REPORTS,
  allReports: L2_MODULES_TEAM_ALL_REPORTS,
  view: L2_MODULES_TEAM_VIEW,
};

export const L2_MODULES_COMPANY = {
  overview: {
    label: meshModules.overview.label,
    value: L3_PATHS.company.overview.myCompanyOverview,
    key: meshModules.overview.value,
    checkModuleIsEnabled: () => checkVisierAnalyticsEnabled() && getUserAccess().isModuleAdmin,
    order: 1,
  },
  goals: {
    label: meshModules.goals.label,
    value: L3_PATHS.company.goal.manage,
    key: meshModules.goals.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasGoalAccess && (getUserAccess().isGoalAdmin || getUserAccess().isCustomGoalAdmin),
    order: 2,
  },
  develop: {
    label: meshModules.develop.label,
    value: L3_PATHS.company.develop.insights,
    key: meshModules.develop.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasFeedbackAccess && (getUserAccess().isFeedbackAdmin || getUserAccess().isCustomFeedbackAdmin),
    order: 3,
  },
  oneOnOne: {
    label: meshModules.oneOnOne.label,
    value: L3_PATHS.company.oneOnOne.insights,
    key: meshModules.oneOnOne.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasOneOnOneAccess && (getUserAccess().isOneOnOneAdmin || getUserAccess().isCustomOneOnOneAdmin),
    order: 4,
  },
  review: {
    label: meshModules.review.label,
    value: L3_PATHS.company.review.manage,
    key: meshModules.review.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasReviewAccess && (getUserAccess().isReviewAdmin || getUserAccess().isCustomReviewAdmin),
    order: 5,
  },
  engagement: {
    label: meshModules.engagement.label,
    value: L3_PATHS.company.engagement.insights,
    key: meshModules.engagement.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasEngagementAccess &&
      (getUserAccess().isEngagementAdmin || getUserAccess().isCustomEngagementAdmin),
    order: 6,
  },
  disciplinaryActions: {
    label: meshModules.disciplinaryActions.label,
    value: L3_PATHS.company.disciplinaryActions.pendingDisciplinaryActions,
    key: meshModules.disciplinaryActions.value,
    checkModuleIsEnabled: () =>
      getUserL2Access().hasDisciplinaryActionsAccess &&
      (getUserAccess().isDisciplinaryActionsAdmin || getUserAccess().isCustomDisciplinaryActionsAdmin),
    order: 6,
  },
};
